<template>
    <div
        class="soli-search-button"
        :class="{ expanded: focused || value }"
        :style="{ width: focused || value ? '254px' : collapsedWidth }"
    >
        <v-btn
            v-show="!focused && !value"
            text
            plain
            small
            :ripple="false"
            class="plain-with-hover-bg"
            @click="focusSearch"
        >
            <v-icon small>{{ icon }}</v-icon
            >{{ placeholder }}
        </v-btn>
        <label
            v-show="focused || value"
            class="soli-search-input-wrap"
            :for="'soli-search-' + _uid"
        >
            <v-icon small class="soli-search-input-icon">{{ icon }}</v-icon>
            <input
                :id="'soli-search-' + _uid"
                ref="searchField"
                type="search"
                :value="value"
                @input="$emit('input', $event.target.value)"
                :placeholder="placeholder"
                @focus="focused = true"
                @blur="onBlur"
                class="soli-search-input"
            />
            <button
                v-if="value"
                type="button"
                class="soli-search-clear"
                aria-label="Clear search"
                @mousedown.prevent
                @click="
                    $emit('input', null);
                    focused = false;
                "
            >
                <v-icon small>{{ icon }}</v-icon>
            </button>
        </label>
    </div>
</template>

<script>
export default {
    props: {
        value: { default: null },
        placeholder: { type: String, default: "Search..." },
        icon: { type: String, default: "clear" },
    },
    data() {
        return {
            focused: false,
        };
    },
    computed: {
        collapsedWidth() {
            return 42 + this.placeholder.length * 6 + "px";
        },
    },
    methods: {
        focusSearch() {
            this.focused = true;
            this.$nextTick(() => {
                this.$refs.searchField?.focus();
            });
        },
        onBlur() {
            if (!this.value) {
                this.focused = false;
            }
        },
    },
};
</script>

<style scoped>
.soli-search-button {
    display: flex;
    align-items: center;
    overflow: hidden;
    transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    font-weight: normal;
}

.soli-search-button.expanded {
    width: 254px;
}

.soli-search-input-wrap {
    display: flex;
    align-items: center;
    height: 32px;
    width: 100%;
    border-radius: 9999px;
    padding: 0 8px 0 8px;
    gap: 4px;
    border: 1px solid transparent;
    background: transparent;
    cursor: text;
    transition: border-color 0.15s;
}

.soli-search-input-wrap:focus-within {
    border-color: var(--v-primary-base, #1976d2);
    outline: 1px solid var(--v-primary-base, #1976d2);
    outline-offset: -1px;
}

.soli-search-input-wrap:focus-within .soli-search-input-icon {
    color: var(--v-primary-base, #1976d2);
    opacity: 1;
}

.soli-search-input-icon {
    flex-shrink: 0;
    opacity: 0.5;
    margin-right: 1px;
}

.soli-search-input {
    flex: 1;
    min-width: 0;
    height: 100%;
    border: none;
    outline: none;
    background: transparent;
    font-size: 0.75rem;
    font-weight: 500;
    color: inherit;
}

.soli-search-input::placeholder {
    color: color-mix(
        in srgb,
        var(--v-contrast-base) 60%,
        transparent
    ) !important;
}

.soli-search-clear {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    padding: 0;
    border: none;
    background: none;
    cursor: pointer;
    opacity: 0.5;
    color: inherit;
}

.soli-search-clear:hover {
    opacity: 1;
}
</style>
